import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator } from '../../../redux/reducers/authSlice';
import TableFooter from '../../../components/TableFooter';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { GetDailyKmAndFuelReportListPagingAndFilterRequest, initialGetDailyKmAndFuelReportListPagingAndFilterRequest } from '../../../models/request/report/GetDailyKmAndFuelReportListPagingAndFilterRequest';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import DailyKmAndFuelReportListFilters from './Components/DailyKmAndFuelReportListFilters';
import { ReportService } from '../../../services/ReportService';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import { GetDailyKmAndFuelReportListPagingAndFilterResponse, GetDailyKmAndFuelReportListPagingAndFilterResponseData, GetDailyKmAndFuelReportListPagingAndFilterResponseItem, initialGetDailyKmAndFuelReportListPagingAndFilterResponseData } from '../../../models/response/report/GetDailyKmAndFuelReportListPagingAndFilterResponse';
import { ExportDailyKmAndFuelReportListResponse } from '../../../models/response/report/ExportDailyKmAndFuelReportListResponse';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';

const DailyKmAndFuelReportList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Raporlar > Günlük Km & Yakıt Raporu"
    const pageVersion = "2";
    const [data, setData] = useState<GetDailyKmAndFuelReportListPagingAndFilterResponseData>(initialGetDailyKmAndFuelReportListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetDailyKmAndFuelReportListPagingAndFilterRequest>(initialGetDailyKmAndFuelReportListPagingAndFilterRequest)

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Tarih', name: 'maxGpsDateTimeStr', order: 0, isVisible: true },
            { title: 'Plaka', name: 'plate', order: 0, isVisible: true },
            { title: 'Yapılan Km', name: 'maxTotalKmDaily', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Tüketilen Yakıt LT', name: 'maxDailySpentFuel', order: 0, isVisible: true, className: 'custom-text-right' },
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)
    }, [])

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetDailyKmAndFuelReportListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            if (_filter.selectedDevices.length == 0 || Helpers.isEmpty(_filter.startDate) || Helpers.isEmpty(_filter.endDate)) {
                toast.error('Lütfen boş alan bırakmayınız!')
                setData(initialGetDailyKmAndFuelReportListPagingAndFilterResponseData);
                return;
            }

            dispatch(storeActivityIndicator(true))

            var response: GetDailyKmAndFuelReportListPagingAndFilterResponse = await ReportService.getDailyKmAndFuelReportListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportDailyKmAndFuelReportListResponse = await ReportService.exportDailyKmAndFuelReportList(buildExcelRequest(filter, mode, [], columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (ReportManager.ApplyDailyKmAndFuelColumnFilters) aynı.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        maxGpsDateTimeStr: { type: 'date' },
        plate: { type: 'text' },
        maxTotalKmDaily: { type: 'number' },
        maxDailySpentFuel: { type: 'number' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetDailyKmAndFuelReportListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        var item2: any = item;
        return <td className={className}>{item2[column]}</td>;
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <DailyKmAndFuelReportListFilters
                    columns={columns}
                    excelExport={excelExport}
                    getColumns={getColumns}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    filter={filter}
                    getData={getData}
                    setFilter={setFilter}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    {/* Arama kutusu kaldırıldı (22.09.2026): raporda hiç çalışmıyordu; kolon
                        başlıklarının altındaki filtreler kullanılır. */}

                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th>{item.title}</th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={0}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr>
                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default DailyKmAndFuelReportList;